import { Title } from 'assets/styles/global.styles';

const NotFound = () => {
    return <Title>Sorry this page not found. 404</Title>;
};

export default NotFound;
